import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { of, Observable } from 'rxjs';
import { VHostService } from './v-host.service';
import { CssPropertiesEnum } from '../models/css-properties.enum';

@Injectable({ providedIn: 'root' })
export class CssService {
  private vHostService = inject(VHostService);
  private document = inject<Document>(DOCUMENT);

  cssEnum = CssPropertiesEnum;
  private stylesId = 'vhost-custom-styles';

  setStyles(): Observable<void> {
    const vHost = this.vHostService.vHost;
    if (!vHost?.css) return of(void 0);

    let cssContent = ':root {\n';
    vHost.css.forEach(style => {
      if (style.key === 'css.customCss') return;

      const key = '--' + Object.keys(this.cssEnum)[Object.values(this.cssEnum).indexOf(style.key)];
      const value = style.value !== '#' ? style.value : 'initial';
      cssContent += `  ${key}: ${value};\n`;
    });
    cssContent += '}\n';

    this.updateStyleElement(this.stylesId, cssContent);
    return of(void 0);
  }

  appendCss(styles: string): void {
    if (!styles) return;
    this.updateStyleElement('vhost-append-css', styles);
  }

  private updateStyleElement(id: string, content: string): void {
    let styleEl = this.document.getElementById(id) as HTMLStyleElement;
    if (!styleEl) {
      styleEl = this.document.createElement('style');
      styleEl.id = id;
      this.document.head.appendChild(styleEl);
    }
    styleEl.textContent = content;
  }
}
